import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginDetails } from '../models/settings/login-details.model';
import { LoginResult } from '../models/settings/login-result.model';
import { AppConfigService } from '../services/app-config.service';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private sessionService: SessionService,
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public isAuthenticated(): boolean {
    return this.sessionService.isAuthenticated();
  }

  public getLoginDetails(): Observable<LoginDetails> {
    return this.http.get<LoginDetails>(`${this.appConfigService.getConfig().apiUrl}authentication/logindetails`);
  }

  public validateLogin(userToken: string, refId: string, values: any): Observable<LoginResult> {
    return this.http.post<LoginResult>(`${this.appConfigService.getConfig().apiUrl}authentication/validatelogin`, { userToken, refId, values });
  }

  public validateLinkGuid(tenantId: string, linkGuid: string): Observable<LoginResult> {
    return this.http.post<LoginResult>(`${this.appConfigService.getConfig().apiUrl}authentication/validatelinkguid`, { tenantId, linkGuid });
  }
}
